import React from "react";
import { X } from "lucide-react";

function tl(n) {
    if (n == null) return "—";
    return `₺${Math.round(Number(n)).toLocaleString("tr-TR")}`;
}

export default function DkIlanModal({ ilan, onClose }) {
    if (!ilan) return null;
    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
            <div className="w-full max-w-md rounded-xl border border-violet-500/30 bg-[#0c1222] p-4 shadow-2xl">
                <div className="flex justify-between items-start gap-2 mb-3">
                    <h4 className="text-sm font-medium text-white">İlan detayı</h4>
                    <button type="button" onClick={onClose} className="text-slate-400 hover:text-white">
                        <X className="h-4 w-4" />
                    </button>
                </div>
                <div className="text-emerald-400 text-xl font-display">{tl(ilan.fiyat)}</div>
                <div className="text-sm text-slate-300 mt-2">{ilan.baslik || "İlan"}</div>
                {ilan.yil ? <div className="text-xs text-slate-500 mt-1">Yıl: {ilan.yil}</div> : null}
                {ilan.km != null ? <div className="text-xs text-slate-500">KM: {Number(ilan.km).toLocaleString("tr-TR")}</div> : null}
                {ilan.url ? (
                    <a
                        href={ilan.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-3 text-xs text-violet-300 hover:underline"
                    >
                        İlan linki →
                    </a>
                ) : null}
            </div>
        </div>
    );
}
